import Icon from '@components/icon';
import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { atiConfLanding } from 'constants/pages';
import { useStore } from 'hooks/useStore';
import { interpolate } from 'utils/string/format';

import bannerPic from './ati-conf-banner@2x.webp';

import css from './AtiConfBanner.module.css';

const AtiConfBanner = () => {
  const { app, atiConfPromo } = useStore();

  if (!atiConfPromo.isBannerVisible) return null;

  return (
    <div className={css.banner}>
      <img alt="" className={css.image} height="122" src={bannerPic.src} width="135" />

      <div className={css.content}>
        <div className={css.textContainer}>
          <p className={cn('glz-p glz-is-size-2 glz-is-bold', css.text)}>{app.i18n.atiConfBanner.title}</p>
          <p className={cn('glz-p glz-is-size-2', css.text, css.description)}>{app.i18n.atiConfBanner.description}</p>
        </div>

        <a
          className="glz-button glz-is-small glz-is-primary glz-is-outlined"
          href={interpolate(atiConfLanding, { env: app.env })}
          rel="noopener noreferrer"
          target="_blank"
        >
          {app.i18n.atiConfBanner.button}
        </a>
      </div>

      <button className={css.closeButton} type="button" onClick={atiConfPromo.closeBanner}>
        <Icon name="ic_close-out" size="s" />
      </button>
    </div>
  );
};

const connected = observer(AtiConfBanner);

export { connected as AtiConfBanner };
